//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Glide from '@glidejs/glide';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/square-carousel.svg';
export default {
  name: 'ProductGlide',
  props: {
    index: {
      type: Number,
      default: 0
    },
    itemsLength: {
      type: Number,
      default: 0
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      slider: null
    };
  },

  computed: {
    hasSingleImage() {
      return this.itemsLength < 2;
    },

    carouselNavigation() {
      return "".concat(this.index + 1, "/").concat(this.itemsLength);
    }

  },
  watch: {
    index(newValue) {
      if (newValue !== this.slider.index) {
        this.slider.enable();
        this.slider.go("=".concat(newValue));
      }
    },

    enabled(value) {
      if (value) {
        this.slider.enable();
      } else {
        this.slider.disable();
      }
    }

  },

  mounted() {
    this.initSlider();
  },

  beforeDestroy() {
    this.slider.destroy();
    this.slider = null;
  },

  methods: {
    initSlider() {
      this.slider = new Glide(this.$refs.glideElement, {
        rewind: false
      }).mount();

      if (!this.enabled) {
        this.slider.disable();
      }

      this.slider.on('run.after', () => {
        if (this.index !== this.slider.index) {
          this.$emit('update:index', this.slider.index);
        }
      });
    },

    isCurrentDot(currentDot) {
      return currentDot - 1 === this.index;
    }

  }
};